import React from 'react';

const Data = () => {
    return (
        <div className="container-fluid py-4 px-3" style={{ backgroundColor: '#dc3545', minHeight: '100vh' }}>

            {/* Header Section */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="p-4 p-md-5 rounded-4 text-white"
                        style={{
                            background: 'linear-gradient(135deg, #dc3545 0%, #a71d2a 100%)',
                            borderRadius: '1.5rem'
                        }}>
                        <h1 className="fw-bold mb-2 fs-2 fs-md-1">India Insurance Landscape 2026</h1>
                        <p className="mb-3 opacity-90 fs-5">
                            Comprehensive analysis of market trends, agent network, and coverage gap
                        </p>
                        <div className="d-flex flex-wrap gap-2 mt-3">
                            <span className="badge rounded-pill px-3 py-2"
                                style={{
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.3s ease',
                                    cursor: 'default'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.35)'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}>
                                📊 Market Size: ₹1.45-1.55 Lakh Crore
                            </span>
                            <span className="badge rounded-pill px-3 py-2"
                                style={{
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.3s ease',
                                    cursor: 'default'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.35)'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}>
                                📈 Growth Rate: 15-17% 
                            </span>
                            <span className="badge rounded-pill px-3 py-2"
                                style={{
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    fontSize: '0.9rem',
                                    transition: 'all 0.3s ease',
                                    cursor: 'default'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.35)'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}>
                                👥 Population: 1.476 Billion
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Key Metrics Row */}
            <div className="row g-3 mb-4">
                {[
                   
                ].map((metric, index) => (
                    <div className="col-md-6 col-lg-3" key={index}>
                        <div className="card border-0 shadow-sm rounded-4 h-100 bg-white"
                            style={{
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-8px)';
                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.2)';
                                e.currentTarget.style.borderLeft = '4px solid #dc3545';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                                e.currentTarget.style.borderLeft = '4px solid transparent';
                            }}>
                            <div className="card-body text-center p-4">
                                <div className="display-5 fw-bold text-danger mb-2">{metric.value}</div>
                                <p className="text-muted mb-0 fw-medium">{metric.label}</p>
                                <small className="text-secondary">{metric.sub}</small>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Agent Network & Demographics */}
            <div className="row g-3 mb-4">
                <div className="col-lg-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100 bg-white"
                        style={{
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                        }}>
                        <div className="card-body p-4">
                            <h4 className="fw-bold mb-3" style={{ borderLeft: '5px solid #dc3545', paddingLeft: '15px', color: '#000000', fontSize: '1.4rem' }}>
                                🏢 Agent Network Overview
                            </h4>
                            <div className="mb-3 p-3 rounded-3" style={{
                                backgroundColor: '#fff5f5',
                                transition: 'all 0.3s ease'
                            }}>
                                {[
                                    { label: 'Total Insurance Workforce', value: '49 Lakh' },
                                    { label: 'Life Insurance Agents', value: '31.5 Lakh' },
                                    { label: 'LIC Agency Network', value: '14.86 Lakh' },
                                    { label: 'Private Life Insurers', value: '16.68 Lakh' }
                                ].map((item, idx) => (
                                    <div className="d-flex justify-content-between align-items-center mb-2" key={idx}
                                        style={{
                                            transition: 'all 0.2s ease',
                                            padding: '4px 8px',
                                            borderRadius: '6px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(220,53,69,0.08)'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        <span className="fw-semibold" style={{ color: '#000000', fontSize: '0.95rem' }}>{item.label}</span>
                                        <span className="badge bg-danger rounded-pill" style={{ width: '100px', textAlign: 'center', fontSize: '0.9rem' }}>{item.value}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-3">
                                <p className="mb-2" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                    <strong>🎯 Future Target:</strong> 1 Crore (10 Million) agents needed for
                                    <em> "Insurance for All by 2047"</em>
                                </p>
                                <p className="mb-2" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                    <strong>👩 Women Representation:</strong> Approximately 30% of agents are women
                                </p>
                                <p className="mb-0" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                    <strong>📈 Agent Growth:</strong> 2.25+ lakh agents added between June 2024 and June 2025
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100 bg-white"
                        style={{
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                        }}>
                        <div className="card-body p-4">
                            <h4 className="fw-bold mb-3" style={{ borderLeft: '5px solid #dc3545', paddingLeft: '15px', color: '#000000', fontSize: '1.4rem' }}>
                                🌍 India Demographics 2026
                            </h4>
                            <div className="mb-3 p-3 rounded-3" style={{ backgroundColor: '#f0fdf4' }}>
                                {[
                                    { label: 'Total Population', value: '1.476 Billion' },
                                    { label: 'Annual Addition', value: '12+ Million' },
                                    { label: 'Median Age', value: '29.2 Years' },
                                    { label: 'Urbanization', value: '37.6%' }
                                ].map((item, idx) => (
                                    <div className="d-flex justify-content-between align-items-center mb-2" key={idx}
                                        style={{
                                            transition: 'all 0.2s ease',
                                            padding: '4px 8px',
                                            borderRadius: '6px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(25,135,84,0.08)'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        <span className="fw-semibold" style={{ color: '#000000', fontSize: '0.95rem' }}>{item.label}</span>
                                        <span className="badge bg-success rounded-pill" style={{ width: '100px', textAlign: 'center', fontSize: '0.9rem' }}>{item.value}</span>
                                    </div>
                                ))}
                            </div>
                            <p className="mb-2" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                <strong>📊 Global Share:</strong> India accounts for over 17.79% of total global population
                            </p>
                            <p className="mb-2" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                <strong>📈 Growth Rate:</strong> 0.86% - 0.89% in 2026
                            </p>
                            <p className="mb-0" style={{ color: '#000000', fontSize: '0.95rem' }}>
                                <strong>🏙️ Density:</strong> Approximately 497 people per km²
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Marketing Trends & Strategies */}
            <div className="row g-3 mb-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm rounded-4 bg-white"
                        style={{
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px)';
                            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.12)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                        }}>
                        <div className="card-body p-4" style={{backgroundColor:'#dc3545'}}>
                            <h4 className="fw-bold mb-4" style={{ 
                                borderLeft: '5px solid #dc3545', 
                                paddingLeft: '15px',
                                fontSize: '1.5rem',
                                fontWeight: '800',
                                color: '#000000'
                            }}>
                                📢 Key Marketing Trends & Core Tactics for 2026
                            </h4>
                            <div className="row g-3">
                                {[
                                    { icon: '🤖', title: 'AI & Automation Integration', desc: 'Insurers adopting AI/ML for predictive analytics. Generative AI creates personalized, emotionally resonant content tailored to customer preferences.' },
                                    { icon: '🎯', title: 'Personalized Customer Experiences', desc: 'Moving beyond generic marketing. Data analytics enables customized policies improving satisfaction and retention.' },
                                    { icon: '🌐', title: 'Omnichannel Digital Presence', desc: 'Integrated approach: Social media (Facebook, LinkedIn, TikTok, YouTube), SEO, and mobile marketing to reach diverse audiences.' },
                                    { icon: '📱', title: 'Social Media Management', desc: 'Direct engagement via LinkedIn & Instagram to build brand awareness and connect with potential customers.' },
                                    { icon: '✉️', title: 'Email Marketing & Automation', desc: 'Segmented lists by policy type/behavior. Automated follow-ups and personalized newsletters drive conversions.' },
                                    { icon: '🤝', title: 'Referral & Community Programs', desc: 'Incentivized referrals and local event sponsorships build trust and leverage word-of-mouth in Tier 2/3 cities.' }
                                ].map((item, idx) => (
                                    <div className="col-md-6 col-lg-4" key={idx}>
                                        <div className="p-3 rounded-3 h-100"
                                            style={{
                                                backgroundColor: '#f8f9fa',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer',
                                                border: '2px solid #dc3545'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#fff5f5';
                                                e.currentTarget.style.transform = 'translateX(5px)';
                                                e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                                e.currentTarget.style.border = '2px solid #dc3545';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                e.currentTarget.style.transform = 'translateX(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                                e.currentTarget.style.border = '2px solid #dc3545';
                                            }}>
                                            <h6 style={{ 
                                                fontWeight: '700', 
                                                color: '#000000', 
                                                fontSize: '1.1rem',
                                                marginBottom: '8px'
                                            }}>
                                                {item.icon} {item.title}
                                            </h6>
                                            <p style={{ 
                                                color: '#000000', 
                                                fontSize: '0.95rem',
                                                fontWeight: '500',
                                                marginBottom: '0',
                                                lineHeight: '1.5'
                                            }}>
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr/>

            {/* Consumer Insights & Emerging Trends */}
            <div className="row g-3" >
                <div className="col-lg-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100 bg-white"
                        style={{
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                        }}>
                        <div className="card-body p-4" style={{backgroundColor:'#dc3545'}}>
                            <h4 className="fw-bold mb-3" style={{ borderLeft: '5px solid #dc3545', paddingLeft: '15px', color: '#000000', fontSize: '1.4rem' }}>
                                🔍 Consumer Perspective
                            </h4>
                            <div className="p-3 mb-3 rounded-3"
                                style={{
                                    backgroundColor: '#fff8e6',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid #dc3545'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.02)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}>
                                <h6 style={{ 
                                    fontWeight: '700', 
                                    color: '#000000', 
                                    fontSize: '1.1rem',
                                    marginBottom: '8px'
                                }}>
                                    ⚠️ The "Wellness Tax" Mindset
                                </h6>
                                <p style={{ 
                                    color: '#000000', 
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    marginBottom: '0',
                                    lineHeight: '1.5'
                                }}>
                                    Younger urban consumers view premiums as a tax — they pay but rarely use the product.
                                    Most healthcare costs are covered out-of-pocket, leading to reliance on employer-sponsored
                                    group plans over individual retail policies.
                                </p>
                            </div>
                            <div className="p-3 rounded-3"
                                style={{
                                    backgroundColor: '#e8f4fd',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid #dc3545'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.02)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}>
                                <h6 style={{ 
                                    fontWeight: '700', 
                                    color: '#000000', 
                                    fontSize: '1.1rem',
                                    marginBottom: '8px'
                                }}>
                                    💡 Technology as Equalizer
                                </h6>
                                <p style={{ 
                                    color: '#000000', 
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    marginBottom: '0',
                                    lineHeight: '1.5'
                                }}>
                                    AI and machine learning will transform risk assessment using national health databases.
                                    This enables fairer, customized premiums and addresses the problem of high costs
                                    driven by adverse selection.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card border-0 shadow-sm rounded-4 h-100 bg-white"
                        style={{
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                        }}>
                        <div className="card-body p-4" style={{backgroundColor:'#dc3545'}}>
                            <h4 className="fw-bold mb-3" style={{ borderLeft: '5px solid #dc3545', paddingLeft: '15px', color: '#000000', fontSize: '1.4rem' }}>
                                🌟 Emerging Focus Areas
                            </h4>
                            <div className="p-3 mb-3 rounded-3"
                                style={{
                                    backgroundColor: '#f0e6f6',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid #dc3545'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.02)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}>
                                <h6 style={{ 
                                    fontWeight: '700', 
                                    color: '#000000', 
                                    fontSize: '1.1rem',
                                    marginBottom: '8px'
                                }}>
                                    👩 Women as Growth Drivers
                                </h6>
                                <p style={{ 
                                    color: '#000000', 
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    marginBottom: '0',
                                    lineHeight: '1.5'
                                }}>
                                    Government initiatives like <strong style={{ color: '#000000' }}>Bima Sakhi Yojana</strong> are bringing women into
                                    the agency workforce. This strategy builds trust through relatable agent networks,
                                    boosting policy uptake among female customers in rural and semi-urban areas.
                                </p>
                            </div>
                            <div className="p-3 rounded-3"
                                style={{
                                    backgroundColor: '#e6f7ee',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid #dc3545'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.02)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.border = '2px solid #dc3545';
                                }}>
                                <h6 style={{ 
                                    fontWeight: '700', 
                                    color: '#000000', 
                                    fontSize: '1.1rem',
                                    marginBottom: '8px'
                                }}>
                                    🏙️ Tier 2 & Tier 3 City Expansion
                                </h6>
                                <p style={{ 
                                    color: '#000000', 
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    marginBottom: '0',
                                    lineHeight: '1.5'
                                }}>
                                    Despite digital growth, the industry still relies heavily on individual agents for
                                    distribution in smaller cities. The massive agency network remains crucial for
                                    penetrating India's underserved semi-urban and rural markets.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Data;


